<p>plan-comptable-show works!</p>
